import {AppConfig} from 'appConfig';
import {defaultsDeep} from 'lodash-es';
import defaultConfig from './default';

const API_ROOT_HOST = 'ci.hg.oems.one';

// TODO
// const MD_URL = `marketdata.${API_ROOT_HOST}/frontend`;
const MD_URL = 'marketdata.uat.hg.oems.one/frontend';

export const hgCommonConfig: AppConfig = defaultsDeep({
    production: true,
    api: {
        root: `https://${API_ROOT_HOST}/client-frontend`,

        defaultStreaming:      'api/v2/stream',
        marketDataStreaming:   `wss://${MD_URL}/api/v2/stream`,
        quotesStreaming:       `wss://${MD_URL}/api/v2/stream`,
        timeAndSalesStreaming: `wss://${MD_URL}/api/v2/stream`,
        optionChainStreaming:  `wss://${MD_URL}/api/v2/stream`,
        ordersCustomFilter:    'api/v1/orders/custom-list'
    },
    defaultSecurityKey: 'BTC/USDT:BINANCE:USDT',
    defaultWatchlistId: defaultConfig.predefinedWatchlistIds['BINANCE_USA'],

    applicationTitle: 'HedgeGuard',

    /**
     * {@link SignUpFlow}
     */
    signUpFlow: 'CLOSED',
    signUpEmailAsUsername: true,
    signUpWithoutApproval: true,
    signUpDisplayReferralIdInput: false,
    resetPasswordFlow: false,

    signUpUrl: null, // Clear in order to use internal sign-up URL.
    logoImageUrl: 'images/hedgeguard-logo.png',
    backofficeLogoImageUrl: 'images/hedgeguard-backoffice-logo.png',
    displayExchange: true,
    defaultDayTimeRange: [
        0, // 00:00 AM

        /**
         * 24:00 PM (excluding the last millisecond according to {@link getDefaultEndDate})
         */
        24 * 60 * 60 * 1000
    ],
    dashboardMaxTabCount: 15
}, defaultConfig);

export default hgCommonConfig;
